import React from "react";
import { useSelector } from "react-redux";
import { selectData } from "../pages/homeSlice";
// Components
import Hero from "../components/Hero";
import AboutMe from "../components/AboutMe";
import Blogs from "../components/Blogs";
import Whitepapers from "../components/Whitepapers";
import Presentations from "../components/Presentations";
import Projects from "../components/Projects";
import { BackToTop } from "../components/globalStyledComponents";
import Footer from "../components/Footer";

export default function Home() {
  const { name } = useSelector(selectData);

  React.useEffect(
    function () {
      document.title = `Brett Hawkins | Public Security Research`;
    },
    [name]
  );

  return (
    <>
      <Hero />
      <main>
        <AboutMe />
        <Blogs />
        <Whitepapers />
        <Presentations />
        <Projects />
      </main>
      <BackToTop home={"Home"} />
      <Footer />
    </>
  );
}
